import queryString from 'query-string';
import { createAxiosInstance } from '@/plugins/axios.plugin';

export class PeriodService {
  static SERVICE_NAME = 'period';

  constructor() {
    this.client = createAxiosInstance({
      baseURL        : process.env.PLATAFORMA_API,
      useAccessToken : true
    });
  }

  getEnrolledPeriods({ state, academicMainTypeName }) {
    const stringified = queryString.stringify({ state, academicMainTypeName });

    let url = '/academic/courses/period/me';

    if (stringified) {
      url += `?${stringified}`;
    }

    return this.client.get(url);
  }

  getAll({ page, name, status, perPage, sortBy, order, selectList }) {
    const stringified = queryString.stringify({ page, name, status, perPage, sortBy, order, selectList }, { skipNull: true, skipEmptyString: true });
    return this.client.get(`academic/courses/period${stringified && `?${stringified}`}`);
  }

  delete(id) {
    return this.client.delete(`academic/courses/period/${id}`);
  }

  edit({ id, name, externalId, startAt, endAt, isActive, periodType }) {
    return this.client.put(`academic/courses/period/${id}`, { id, name, externalId, startAt, endAt, isActive, periodType });
  }

  create({ name, externalId, startAt, endAt, isActive, periodType }) {
    return this.client.post('academic/courses/period', {
      name, externalId, startAt, endAt, isActive, periodType
    });
  }
}

export default new PeriodService();